import { __assign } from "tslib";
import { IdentityProvider } from '@office-start/auth-types';
import { logFeature } from '@office-start/telemetry-service';
export function redirectToLogin(identity, eventNameSuffix, additionalParams) {
    if (additionalParams === void 0) { additionalParams = {}; }
    var commonParams = {
        IsChat: window.location.pathname === '/chat',
        UrlHost: window.location.origin,
    };
    var params = __assign(__assign({}, commonParams), additionalParams);
    logFeature({
        featureName: "Auth" /* KnownFeatureNames.Auth */,
        eventName: 'HybridAuth_Reauth_' + eventNameSuffix,
        params: params,
    });
    var IdentityProviderKey = 'IdentityProvider';
    var username = identity.userPrincipalName || '';
    var identityProvider = identity.isMsa
        ? IdentityProvider.MSA
        : IdentityProvider.AAD;
    var urlParams = new URLSearchParams(window.location.search);
    urlParams.set('from', eventNameSuffix);
    urlParams.set(IdentityProviderKey, identityProvider.toString());
    var urlParamsString = urlParams.toString();
    var queryParams = urlParamsString ? '?' + urlParamsString : '';
    window.location.assign("/login?login_hint=".concat(username, "&ru=").concat(encodeURIComponent(window.location.pathname + queryParams)));
}
//# sourceMappingURL=redirectToLogin.js.map